import sendUserEvent from "../../userEvents/sendUserEvent";

const assignSitePopupBridge = (window, {
    close,
    username,
    isTrial,
    isFirstAdmin,
}) => {
    window.SitePopupBridge = {
        close,
        sendUserEvent,
        context: {
            username,
            isTrial,
            isFirstAdmin,
        },
    }
}

export default assignSitePopupBridge



// WEBPACK FOOTER //
// ./web/js/support/welcomeScreen/SitePopupBridge.js